import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_ROTATION",
    applicationRights: Rights,
    title: 'T&oslash;rn',
    text: 'T&oslash;rn',
    icon: 'arrows-counter-clockwise',
    showOnDashboardByDefault: false,
    url: "/pilot-rotation/CURRENT",
    routes: Routes
})
